module.exports = __webpack_public_path__ + "images/favicon-32x32.png";